module.exports = __webpack_public_path__ + "img/gimlet.d7d65f48.jpg";